import { CommonSettingsKeys } from '../constants';

import { FieldData } from './common';

export interface CommonSettings {
    orderPrioritySettings: OrderPriorityCommonSettings;
    balanceSettings: BalanceCommonSettings;
    teamLeadCommissionSettings: TeamLeadCommissionCommonSettings;
}

export interface OrderPriorityCommonSettings {
    [CommonSettingsKeys.TraderOrderShare]: string;
    [CommonSettingsKeys.NewTraderOrderShare]: string;
    [CommonSettingsKeys.OperatorOrderShare]: string;
}

export interface BalanceCommonSettings {
    [CommonSettingsKeys.MinTrustBalance]: string;
    [CommonSettingsKeys.MinTradeBalance]: string;
}

export interface TeamLeadCommissionCommonSettings {
    [CommonSettingsKeys.TeamLeadPayinCommissionRate]: string;
    [CommonSettingsKeys.TeamLeadPayoutCommissionRate]: string;
}

export type CommonSettingsUnionKeys = OrderPriorityCommonSettings &
    BalanceCommonSettings &
    TeamLeadCommissionCommonSettings;

export interface CommonSettingsResponse {
    orderPrioritySettings: FieldData[];
    balanceSettings: FieldData[];
    teamLeadCommissionSettings: FieldData[];
}
